"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRubyJackpotActions = void 0;
var IRubyJackpotActions;
(function (IRubyJackpotActions) {
    IRubyJackpotActions["SET_GAMES"] = "set_games";
    IRubyJackpotActions["SET_LATEST_WINNERS"] = "set_latest_winners";
    IRubyJackpotActions["SET_SHORT_STATISTICS"] = "set_short_statistics";
})(IRubyJackpotActions = exports.IRubyJackpotActions || (exports.IRubyJackpotActions = {}));
